import $ from 'jquery';
import { wait } from '../utils/helpers';
import { ENV, URL_PARAMS } from '../utils/constants';

const TIMEOUT = 5000;
let isChatReady = false;
let closeChatTimeoutId;
let products = [];
// Pulls all products from global product array
for (const prod in window.projectGlobals.products) {
  products.push(window.projectGlobals.products[prod].id);
}
export const supportedProducts = products;

// Recieve links from chat
// - handle them, pop ups etc, reload page, etc
$('body').addClass('webchat-closed');

window.addEventListener(
  'message',
  function (event) {

    if (typeof event.data !== 'string') {
      return;
    }

    let message;
    try {
      message = JSON.parse(event.data);
    } catch (e) {
      return;
    }

    if ( ENV === 'DEV' || ENV === 'STAGE' ) {
      console.log(message);
    }

    if (message.type === 'aisera.webchat.opened') {
      $('body').addClass('webchat-opened');
      $('body').removeClass('webchat-closed');
    }

    if (message.type === 'aisera.webchat.closed') {
      $('body').addClass('webchat-closed');
      $('body').removeClass('webchat-opened');
    }

    if (message.type === 'aisera.webchat.link_clicked') {
      // Should have this beahvior:
      // - HTML LRD (eg https://www.askgileadmedical.com/docs/trodelvy/trodelvy-reports-of-alopecia ) opens in same tab with reload
      // - PDF LRD opens in new tab
      // - any link with GILEAD in it opens in new tab without modal
      // - non gilead owned links open with modal confirming user wants to leave, opens in enw tab

      const url = new URL(message.href);

      console.log(url.pathname.toLowerCase());

      if ( url.searchParams.has('openTab') && url.searchParams.get('openTab') === 'inquiry' ) {
        sendPostMessage({ type: 'aisera.webchat.close' });

        setTimeout(() => {
          $('.js-modal-trigger[data-modal="inquire"]').trigger('click');
        }, 300);
      } else if ( message.href.toLowerCase().includes('tel:') ) {
        let href = message.href;
        href = href.replaceAll('-', '');
        href = !href.includes('+')
          ? href.replace('tel:', 'tel:+')
          : href;

        window.open(href);
      } else if ( url.hostname.toLowerCase().includes('askgileadmedical') ) {
        pushGTMEvent(message.href, 'website');

        if ( url.pathname.toLowerCase().includes('/docs/') ) {
          localStorage.setItem('openChat', true);
        }

        window.location = message.href;
      } else if (
        url.hostname.toLowerCase().includes('gilead') ||
        url.pathname.toLowerCase().includes('/pdfs/') ||
        url.pathname.toLowerCase().includes('.pdf') ||
        url.pathname.toLowerCase().includes('gileaduschat')
      ) {
        pushGTMEvent(message.href, 'internal');

        window.open(message.href, '_blank');
      } else if ( !url.hostname.toLowerCase().includes('gilead') ) {
        pushGTMEvent(message.href, 'external');

        const elemLink = $('<a />');

        elemLink.attr('href', message.href);
        elemLink.attr('target', '_blank');
        elemLink.attr('data-modal', 'leave');
        elemLink.addClass('js-modal-trigger');

        $('body').append(elemLink);
        elemLink.trigger('click');
        elemLink.remove();
      }
    }

    if (message.type === 'aisera.webchat.ready') {
      isChatReady = true;
    }
  },
  false
);

// Check if chat is initialized
export const isChatInitialized = () => isChatReady;

// Send postMessage to chatbot
export const sendPostMessage = async (data) => {
  await wait(isChatInitialized);

  window.postMessage(JSON.stringify(data), '*');
};

// Open chat on first load
/*
$('.js-entry-pop-btn[data-type="hcp"]').on('click', async () => {
  if ( $(window).width() >= 768 ) {
    await wait(isChatInitialized);

    sendPostMessage({ type: 'aisera.webchat.open' });
    closeChatAfterInactivity();
  }
});
*/

// Close chat after timeout
export const closeChatAfterTimeout = () => {
  clearTimeout(closeChatTimeoutId);

  closeChatTimeoutId = setTimeout(() => {
    sendPostMessage({ type: 'aisera.webchat.close' });
    $('#awc-webchat').off('.interact');
  }, TIMEOUT);
};

// Close chat if the user hasn't interacted with it
export const closeChatAfterInactivity = async () => {
  await wait(isChatInitialized);

  setTimeout(() => {
    $('#awc-webchat').trigger('blur').trigger('mouseout');
  }, 400);

  $('#awc-webchat').on('mouseover.interact click.interact mousewheel.interact', () => {
    clearTimeout(closeChatTimeoutId);
  }).on('mouseout.interact', () => {
    closeChatAfterTimeout();
  });
};

// Push event to GTM
const pushGTMEvent = (url, type) => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    'event': 'chat-link-navigation',
    'url': url,
    'type': type,
  });
};

// Open chat on LRD HTML pages
if (
  window.location.pathname.toLowerCase().includes('/docs/') &&
  ( localStorage.hasOwnProperty('openChat') && localStorage.getItem('openChat') === 'true' ) ||
  ( URL_PARAMS.has('utm_medium') && URL_PARAMS.get('utm_medium') === 'chat' )
) {
  wait(isChatInitialized)
    .then(() => {
      sendPostMessage({ type: 'aisera.webchat.open', source : 'website' });
      closeChatAfterInactivity();
      localStorage.removeItem('openChat');
    });
}

// Chat features
/*
 * Open chat
 *
      {
        type: 'aisera.webchat.open'
      }

 * Open chat with message from user
 *
      {
        type: 'aisera.webchat.open',
        text: '[Product] [query]'
      }

 * Close chat
      {
        type: 'aisera.webchat.close',
      }

 * Example code to send message to Aisera chat
setTimeout(() => {
  window.postMessage(
    JSON.stringify(
      {
        type: 'aisera.webchat.open', // opens chat
        text: 'trodelvy storage'     // search term
      }
    ),
    '*'
  );
}, 500);
 */



// WEBPACK FOOTER //
// ./src/assets/js/project/chat.js